import React from "react"
import styled from "styled-components"
import Link from "next/link"

import WinItButton from "~/components/WinItButton"
import ErrorPage from "~/components/ErrorPage"

const Fill = styled.div`
  display: flex;
  flex: 1;
`

const ERROR_CODES = {
  404: (
    <>
      Wrong turn, driver. 🚗
      <br />
      This path does not exist. 🛣
    </>
  )
}

const getErrorMessage = statusCode => {
  if (!statusCode) return "An error occurred on client"
  if (ERROR_CODES[statusCode]) return ERROR_CODES[statusCode]
  return `An error occurred on server`
}

class Error extends React.Component {
  static getInitialProps({ res, err }) {
    let statusCode = null
    if (res && res.statusCode) {
      statusCode = res.statusCode // eslint-disable-line
    }
    if (err && err.statusCode) {
      statusCode = err.statusCode // eslint-disable-line
    }
    return { statusCode }
  }

  render() {
    return (
      <ErrorPage>
        {this.props.statusCode ? (
          <>
            <h1>{this.props.statusCode}</h1>
            <h3>{getErrorMessage(this.props.statusCode)}</h3>
          </>
        ) : (
          <h3>Oops, something went wrong.</h3>
        )}
        <Fill />
        <Link href="/">
          <WinItButton
            onClick={this.goToOldApplication}
            padding="0 40px"
            color="blue"
            maxWidth="300px"
          >
            Take me home
          </WinItButton>
        </Link>
      </ErrorPage>
    )
  }
}

export default Error
